<template>
  <v-btn
    outlined
    @click="showContextualHelp(true)"
  >
    <v-icon left>
      help
    </v-icon>
    Help
  </v-btn>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  methods: {
    ...mapMutations('help', [ 'showContextualHelp' ])
  }
}
</script>

<style>

</style>
